import * as RoutePathConstants from '../../../../../../constants/RoutePathConstants'
import { API_BASE_URL } from '../../../../../../common/utils/commonUrl'
import http from '../../../../../../common/utils/http'
import { DOWNLOAD_FILE, UPLOAD_FILE } from '../../../../../../common/utils/uploadFileUtil'
import moment from 'moment'

export default {
  data () {
    return {
      memberInfoForm: {
        memberPhone: "",
        definitionId: "",
      },
      memberInfoRules: {
        memberPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[0-9]{10}$/, message: '请输入11位手机号' }
        ],
        definitionId: [
          { required: true, message: '请选择车型', trigger: 'blur' }
        ]
      },
      carTypeList: []
    }
  },
  methods: {
    async submit () {
      console.log(this.memberInfoForm, 'this.memberInfoFormthis.memberInfoForm')
      this.$refs['memberForm'].validate(async (valid) => {
        if (valid) {
          http.post(API_BASE_URL + '/api/wxoa/member/memberBasis/addTestDriveReservation', this.memberInfoForm)
            .then(
              res => {
                this.$message.success('预约成功!')
                setTimeout(this.$router.go(-1), 3000)
              }
            )
            .catch(
              err => {
                this.$message.error(err.data.message);
              }
            )


        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 获取试驾列表
    getTestDriveDefinitionAndAttachmentPageList () {
      http.get(API_BASE_URL + '/api/wxoa/member/memberBasis/getTestDriveDefinitionAndAttachmentPageList?pageNum=1&pageSize=100').then(
        res => {
          console.log(res.data.data, "获取试驾列表")
          this.carTypeList = res.data.data.dataList.map(item => {
            return {
              definitionId: item.id,
              vehicleName: item.vehicleName
            }
          })
        }
      )
    }

  },
  mounted () {
    this.getTestDriveDefinitionAndAttachmentPageList()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-home-page-new/views/test-drive/test-drive.js